import {omit} from 'external/lodash'
import { FC, useNavigate, Button, ButtonProps} from 'external/react'
import Icon from 'external/fortawesome'

type ButtonBackProps = {
	path: any
} & Partial<ButtonProps>

const ButtonBack : FC<ButtonBackProps> = props => {
	const {path} = props
    const navigate = useNavigate()
	const buttonProps = omit(props, ['path'])
	return (
		<Button
			variant='outline-secondary'
			size='sm'
			style={{ marginBottom: '5px', width: '32px', marginRight: '10px' }}
			onClick={() => navigate(path)}
			{...buttonProps}
		>
			<Icon name="faChevronLeft" />
		</Button>
	);
};

export default ButtonBack;
